
import { css } from 'lit';
export default css`
.toggle {
  display: inline-flex;
  border-radius: 0.25rem;
  border-width: 1px;
  padding: 0.25rem;
  border-color: rgba(14, 0, 51, 0.2);
}

  .toggle__item {
  display: flex
}

  .toggle__item {
  align-items: center
}

  .toggle__item {
  padding: 0.5rem
}

  .toggle__item {
  font-size: 0.875rem
}

  .toggle__item {
  font-weight: 500
}

  .toggle__item {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity))
}

  .toggle__item {
    white-space: nowrap
  }

  @media (min-width: 360px) {

  .toggle__item {
    font-size: 1rem
  }
}

  @media (min-width: 1024px) {

  .toggle__item {
    padding-left: 1rem;
    padding-right: 1rem
  }
}

  @media (min-width: 1024px) {

  .toggle__item {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
  }
}

  .toggle__item--icon {
  margin-right: 0.5rem
}

  .toggle__item--icon {
  width: 1rem
}

  .toggle__item--icon[name="map"] {
        width: 24px;
        height: 24px;
      }

  .toggle__item--icon[name="list"] {
  margin-top: -2px
}

  .toggle__item--icon[name="list"] {
        width: 21px;
        height: 18px;
      }

  @media (min-width: 1024px) {

  .toggle__item--icon {
    margin-right: 1rem
  }
}

  @media (min-width: 1024px) {

  .toggle__item--icon {
    width: 1.5rem
  }
}

  .toggle__item--active {
  border-radius: 0.25rem
}

  .toggle__item--active {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity))
}

  .toggle__item--active {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity))
}
`;